import { animated } from 'react-spring';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const FloatingWrapper = styled.div`
  position: fixed;
  bottom: 16px;
  right: 16px;
`;

const FloatingButton = styled(animated.button)`
  width: 56px;
  height: 56px;
  margin-top: 14px;
  background-color: ${ColorPalette.HEX.PineTree};
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${ColorPalette.HEX.White};
`;

type ToggleButtonProps = {
  $isOpen: boolean;
};

export const FloatingToggleButton = styled(FloatingButton)<ToggleButtonProps>`
  transition: background-color 250ms;
  background-color: ${({ $isOpen }) => ($isOpen ? ColorPalette.HEX.White : ColorPalette.HEX.PineTree)};
  box-shadow: ${({ $isOpen }) => ($isOpen ? `0 2px 12px 0 rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16)` : 'none')};
`;

export const FloatingToggleButtonIcon = styled(animated.img)`
  position: fixed;
`;

export const FloatingAction = styled(FloatingButton)``;
